// @ts-nocheck
import { initCriticalGlobalLoader, initDynamicLoadersCleanup } from "./utils/dynamicLoaders.js";

import "../../base/js/init.js";
import "../../base/js/utils/preCommonUtils.js";
import "../../../components/bhg/image.js";
import "../../base/js/utils/ajaxUtils.js";
import "../../base/js/utils/customContextHubUtils.js";
import "../../base/js/utils/styleLoader.js";
import "../../base/js/shared/loading.js";

const runOnIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 50));

initCriticalGlobalLoader();

const initRTL = function () {
  const rtlLangs = ["ar-AE", "ar", "ar-ww", "ar-ae", "he-IL"];
  let observer = null;

  const checkLang = function () {
    const currentLang = document.documentElement.lang;
    const isRTL = rtlLangs.some(function (lang) {
      return currentLang.includes(lang);
    });

    if (isRTL) {
      if (window.bcl && window.bcl.u && typeof window.bcl.u.loadStyleSheet === "function") {
        window.bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-rtl.css");
      }

      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }
  };

  checkLang();

  if (
    !observer &&
    !rtlLangs.some(function (l) {
      return document.documentElement.lang.includes(l);
    })
  ) {
    observer = new MutationObserver(checkLang);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });
  }
};

const main = function () {
  runOnIdle(function () {
    initDynamicLoadersCleanup();
    initRTL();
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", main, { once: true });
} else {
  main();
}
